import React from "react";

function TeamRevenueAnalysis({ chart_data }) {
    let data = [];
    chart_data?.forEach((item) => {
      data.push({
        name: item.member_name,
        searches_closed: item.searches_closed,
        business_delivered: `₹ ${(Number(item.business_delivered) / 10000000).toFixed(2)} Cr`,
        clients_managed: item.clients_managed,
        avg_collection_days: item.avg_collection_days,
      });
    });

  return (
    <>
      <style>
        {`
            .table thead tr th {
                white-space: normal !important;
                word-wrap: break-word;
                padding: 6px 8px;
            }
            
            .table tbody tr td {
            color : #202c4b;
            }
        `}
      </style>
      <div className="table-responsive">
        <table className="table table-hover mb-0">
          <thead>
            <tr>
              <th></th>
              <th>Searches Closed</th>
              <th>Business Delivered</th>
              <th>Clients Managed</th>
              <th>Avg Collection Days</th>
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 &&
              data?.map((item, index) => {
                return (
                  <tr>
                    <td>{item?.name}</td>
                    <td>{item?.searches_closed}</td>
                    <td>{item?.business_delivered}</td>
                    <td>{item?.clients_managed}</td>
                    <td>{item?.avg_collection_days}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default TeamRevenueAnalysis;